export enum ExtraPaymentAuthorValue {
  FACTORY = "447e8862-1429-4e6c-bba4-6cbd885aaa77",
  OPERATOR = "96e3a6e6-f4cd-451d-96b4-826a70ebcbd2",
}
